import { anonymousRequest } from "common/src/utils/request";
import { helpers, required } from "@vuelidate/validators";
import { AxiosResponse } from "axios";
import { computed } from "vue";

/**
 * API0010 ログインAPI リクエストインターフェース
 */
export type LoginRequest = {
  /** ユーザーID */
  userId: string;
  /** パスワード */
  password: string;
  /** 認証タイプ */
  authType: string;
};

/**
 * API0010 ログインAPI レスポンスインターフェース
 */
export type LoginResponse = {
  /** アクセストークン */
  accessToken: string;
  /** リフレッシュトークン */
  refreshToken: string;
};

/**
 * API0010 ログイン バリデーションルール
 */
export const loginValidateRule = computed(() => ({
  userId: {
    required: helpers.withMessage("ログインIDが入力されていません", required),
  },
  password: {
    required: helpers.withMessage("パスワードが入力されていません", required),
  },
}));

/**
 * API0010 ログイン
 * @param login
 * @returns
 */
export const postLogin = async (login: LoginRequest): Promise<AxiosResponse<LoginResponse>> => {
  login.authType = "0";
  return await anonymousRequest.post("/v1/login", login);
};
